import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { MaskLines, EASE } from "@/components/motion/Reveal";

export const PageHero = ({ eyebrow, lines, sub, img, testId }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start start", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["0%", "25%"]);
  return (
    <section ref={ref} className="relative flex min-h-[78svh] items-end overflow-hidden pb-20 pt-40" data-testid={testId}>
      {img && (
        <motion.div style={{ y }} className="absolute inset-0">
          <motion.img initial={{ scale: 1.2, opacity: 0 }} animate={{ scale: 1.05, opacity: 0.55 }} transition={{ duration: 1.8, ease: EASE }} src={img} alt="" className="h-full w-full object-cover" />
        </motion.div>
      )}
      <div className="absolute inset-0 bg-gradient-to-t from-ink-950 via-ink-950/70 to-ink-950/40" />
      <div className="dot-grid absolute inset-0 opacity-40" />
      <div className="container-x relative">
        <motion.p initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.6, duration: 0.8 }} className="eyebrow flex items-center gap-3">
          <span className="h-px w-10 bg-volt" /> {eyebrow}
        </motion.p>
        <h1 className="mt-6 font-display text-5xl font-black uppercase leading-[0.9] tracking-[-0.04em] text-white sm:text-6xl lg:text-8xl">
          <MaskLines delay={0.75} lines={lines} lineClass={(i) => (i === 1 ? "text-outline" : "")} />
        </h1>
        {sub && (
          <motion.p initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 1.1, duration: 0.9, ease: EASE }} className="mt-8 max-w-xl text-base leading-relaxed text-slate-300 md:text-lg">
            {sub}
          </motion.p>
        )}
      </div>
    </section>
  );
};
